module.exports = __webpack_public_path__ + "img/png_tszp_2@2x.028539d4.png";